import { tabularTraineesWithFixedColumns } from "./tabular_trainees";
import { versionnedStorageKey, maybeRemoveHeader } from "../framework/tabulars";

import {
  pagination,
  optionsToolbar,
  checkBatchButtonsAndPopupWarning,
  changeSearch,
  createDatagrid,
  datagridDefaultOptions,
  filtersClearButton,
} from "../utils/devextreme_utils";

let dataGrid;
const searchSelector = "#trainees-search";
const storageKey = versionnedStorageKey("trainees-datagrid", 2);

$(document).on("click", ".js-select-trainees-page .add-trainees-tabular", onAdded);

document.addEventListener("DOMContentLoaded", function () {
  const { trainingSessionId, customerId } = document.getElementById("datagrid")?.dataset || {};
  if ($(".js-select-trainees-page").length > 0 && trainingSessionId) {
    createDatagrid(({ default: DataGrid }) => {
      dataGrid = createTable(DataGrid, p`/training_sessions/${trainingSessionId}/tabular?customer_id=${customerId}`);
      return dataGrid;
    }).then((dataGrid) => {
      document.querySelector(".trainees-columns-chooser").addEventListener("click", () => dataGrid.showColumnChooser());
      document.querySelector(searchSelector).addEventListener("input", (_e) => changeSearch(dataGrid, searchSelector));
    });
  }
});

function createTable(DataGrid, dataSource) {
  return new DataGrid(document.querySelector("#datagrid"), {
    ...datagridDefaultOptions(),
    dataSource,
    columns: columns(),
    allowColumnResizing: false,
    allowColumnReordering: true,
    columnAutoWidth: true,
    rowAlternationEnabled: false,
    showColumnLines: false,
    stateStoring: {
      enabled: true,
      type: "custom",
      customLoad: function () {
        const filters = JSON.parse(localStorage.getItem(storageKey));
        if (filters) filters.selectedRowKeys = [];

        return filters;
      },
      customSave: function (state) {
        state.searchText = "";
        state.selectedRowKeys = [];
        localStorage.setItem(storageKey, JSON.stringify(state));
      },
    },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },
    onContentReady: function (container) {
      onDataReady();
      maybeRemoveHeader(container);
    },
    export: {
      enabled: false,
    },
    ...optionsToolbar,
    ...pagination(),
    selection: {
      mode: "multiple",
      showCheckBoxesMode: "always",
    },
    onSelectionChanged: () => checkBatchButtonsAndPopupWarning(dataGrid),
  });
}

function columns() {
  const elt = document.getElementById("datagrid");

  const traineeFields = JSON.parse(elt.getAttribute("data-trainee-fields"));
  const traineeColumns = tabularTraineesWithFixedColumns(traineeFields, [
    "trainee_lastname",
    "trainee_firstname",
    "trainee_second_lastname",
  ]);
  const customFields = JSON.parse(elt.getAttribute("data-custom-fields"));

  const columns = [...traineeColumns, ...customFields];
  return filtersClearButton(columns);
}

function onAdded(e) {
  e.preventDefault();
  e.stopPropagation();
  const ids = dataGrid.getSelectedRowKeys().map((x) => x.trainee_id);
  $(".add-trainees-tabular input[name=trainee_ids]").val(JSON.stringify(ids));

  $(".add-trainees-tabular").trigger("submit");
}

function onDataReady() {
  const searchPanel = dataGrid.option().searchPanel.text;
  if (document.querySelector(searchSelector)) {
    document.querySelector(searchSelector).value = searchPanel;
  }
}
